import { render } from "./AudioPlayerComp.vue?vue&type=template&id=2421ef49&scoped=true&ts=true"
import script from "./AudioPlayerComp.vue?vue&type=script&lang=ts"
export * from "./AudioPlayerComp.vue?vue&type=script&lang=ts"

import "./AudioPlayerComp.vue?vue&type=style&index=0&id=2421ef49&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2421ef49"]])

export default __exports__